<template>
  <div>
    <v-app-bar
      flat
      class="menu-toolbar"
      :class="{
        'menu-toolbar-logged-in': isLoggedIn,
        'menu-toolbar-mobile': isMobile,
      }"
      color="white"
    >
      <v-menu content-class="nav-mobile-menu">
        <template #activator="{ on }">
          <v-btn
            icon
            v-on="on"
            :class="{
              hidden: showDesktopNav,
            }"
          >
            <v-icon>{{ icons.mdiMenu }}</v-icon>
          </v-btn>
        </template>
        <v-list>
          <div v-for="item in menuItems()" :key="item.title">
            <v-list-item
              v-if="!item.hide && item.action === 'request_advisor_access'"
              class="mobile-menu-list-item"
            >
              <v-btn
                @click="actionSelected(item.action)"
                :target="item.target"
                text
                class="mobile-menu-link"
                :ripple="false"
              >
                {{ item.title }}
              </v-btn>
            </v-list-item>
            <v-list-item
              v-else-if="!item.hide && !item.action"
              class="mobile-menu-list-item"
            >
              <v-btn
                :href="item.href"
                :to="item.to"
                :target="item.target"
                text
                class="mobile-menu-link"
              >
                {{ item.title }}
              </v-btn>
            </v-list-item>
          </div>
        </v-list>
      </v-menu>

      <v-toolbar-title
        class="menubar-title"
        :style="{ width: whitelabel.brand !== 'quickwill' ? '10%' : 'unset' }"
      >
        <router-link to="/overview" class="logo-link">
          <img
            v-if="coBrandCompanyUrl"
            :src="coBrandCompanyUrl"
            alt="Company logo"
            :title="'co-branding-logo'"
            class="menubar-logo company-logo"
          />
          <img
            v-else-if="companyLogoUrl"
            :src="companyLogoUrl"
            alt="Company logo"
            :title="testator.company.tradingName + ' logo'"
            class="menubar-logo company-logo"
          />
          <img
            v-else-if="logoUrl"
            :src="logoUrl"
            alt="Logo"
            title="Logo"
            class="menubar-logo internal-main-logo"
          />
          <div v-else-if="whitelabel.cssLogo" class="internal-logo-css-only" />
          <span v-if="companyLogoUrl" class="powered-by"
            >POWERED BY {{ whitelabel.name }}</span
          >
        </router-link>
        <img
          v-if="companyLogoUrl && logoUrl"
          :src="logoUrl"
          alt="Logo"
          title="Logo"
          class="menubar-logo right-side-logo"
        />
      </v-toolbar-title>
      <v-toolbar-items v-if="showDesktopNav">
        <div v-for="item in menuItems()" :key="item.title" class="ma-auto">
          <v-btn
            v-if="!item.hide && item.action !== 'request_advisor_access'"
            class="menu-btn"
            :ripple="false"
            :href="item.href"
            :to="item.to"
            :target="item.target"
            :class="item.class"
            text
          >
            {{ item.title }}
          </v-btn>
        </div>
      </v-toolbar-items>
      <v-spacer />
      <RequestAdivsorAccess
        @closedDialog="closedDialog"
        :dialogOpen="advisorAccessDialogOpen"
        v-if="
          showLoginAndSignupBtns && this.whitelabel.showAdvisorAccessRequest
        "
      />
      <v-btn
        v-if="showLoginAndSignupBtns"
        rounded
        depressed
        outlined
        color="primary"
        to="/login-qw"
        >Log in</v-btn
      >
      <v-btn
        v-if="showLoginAndSignupBtns"
        rounded
        depressed
        color="primary"
        class="signup-btn"
        to="/signup"
        >Sign Up</v-btn
      >

      <request-a-call-btn v-if="showRequestACallBtn" />
      <a
        v-if="showSpeakToAnAdvisor"
        @click="speakToAnAdvisorClicked"
        class="ml-0 v-btn v-btn--outlined v-btn--rounded v-btn--text theme--light v-size--default primary--text"
        target="_blank"
        >Speak to an advisor</a
      >

      <GradientButton
        v-if="whitelabel.omDesign && isLoggedIn"
        :title="'Log Out'"
        @gradientButtonClicked="logout"
        isLogoutButton="true"
        :button-size="isMobile ? 'small' : 'medium'"
      />
      <v-btn
        v-else-if="!whitelabel.omDesign && isLoggedIn"
        rounded
        depressed
        outlined
        color="primary"
        @click="logout"
        >Log out</v-btn
      >
    </v-app-bar>
    <v-row class="partnered-with" v-if="coBrandCompanyUrl">
      <v-col class="text-center partnered-with-text font-weight-medium">
        We've partnered with {{ coBrandCompanyName }} to offer you a
        {{ companyOffersFreeWill ? 'free will.' : 'will.' }}
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { mdiMenu } from '@mdi/js';
  import { LOGOUT_MUTATION } from '../../constants/graphql/authentication';
  import { TESTATOR_STEPS_QUERY } from '../../constants/graphql/overview';
  import { GET_ADVISOR_APPOINTMENT_LINK } from '../../constants/graphql/testators';
  import RequestACallBtn from './RequestACallBtn.vue';
  import { mapGetters } from 'vuex';
  import RequestAdivsorAccess from './RequestAdvisorAccess.vue';
  import Steps from '../../helpers/steps';
  import { logoutAsTestatorMixin } from '../../mixins/logout-as-testator';

  export default {
    name: 'NavBar',
    components: {
      RequestACallBtn,
      RequestAdivsorAccess,
    },
    mixins: [logoutAsTestatorMixin],
    data() {
      return {
        advisorAccessDialogOpen: false,
        drawer: null,
        icons: {
          mdiMenu: mdiMenu,
        },
        testator: null,
        steps: [],
        testatorSteps: {},
      };
    },
    watch: {
      testator() {
        this.steps = Steps.getCalculatedSteps(
          this.testator,
          this.testatorSteps,
          this.testator.enabledFeatures,
          this.whitelabel.images
        );
      },
    },
    computed: {
      ...mapGetters(['coBrandCompanyUrl']),
      ...mapGetters(['coBrandCompanyName']),
      ...mapGetters(['companyOffersFreeWill']),
      loggedInItems() {
        const loggedInItems = [
          { title: 'Overview', to: '/overview' },
          {
            title: 'FAQs',
            href: this.whitelabel.FAQUrl,
            target: '_blank',
            hide: !this.whitelabel.blogUrl || this.isAdvisor,
          },
          {
            title: `${
              this.whitelabel.brand === 'oldmutual' ||
              this.whitelabel.brand === 'teba'
                ? 'Articles'
                : 'Blog'
            }`,
            href: this.whitelabel.blogUrl,
            target: '_blank',
            hide: !this.whitelabel.blogUrl || this.isAdvisor,
          },
          {
            title: 'Executorship',
            to: '/executor-explainer',
            hide: !this.showExecutorship,
          },
          {
            title: 'Edit my people',
            to: '/people-overview',
            hide: !this.showEditMyPeople,
            class: 'edit-my-people',
          },
          {
            title: 'Manage account',
            to: '/manage-account',
            hide: this.isLoggedInAsSomeoneElse,
          },
          {
            title: 'Will verification',
            to: '/will-verification',
            hide: !this.showWillVerification,
          },
          {
            title: 'Document Vault',
            to: '/my-documents',
            hide: !this.showMyDocuments,
          },
          {
            title: 'Referrals',
            to: '/referrals',
            hide: this.hideReferAFriend,
          },
          {
            title: 'Advisor Dashboard',
            to: '/advisors',
            hide: !this.canSeeAdvisorDashboard,
          },
        ];

        return loggedInItems;
      },
      allStepsCompleted() {
        return this.numberOfCompletedSteps === this.numberOfSteps;
      },
      numberOfCompletedSteps() {
        return this.steps.filter(s => s.completed == true).length;
      },
      numberOfSteps() {
        return this.steps.length;
      },
      referAFriendEnalbed() {
        return this.testator?.company?.referAFriend && this.allStepsCompleted;
      },
      isTestator() {
        return this.$store.getters.isTestator;
      },
      isAdvisor() {
        return this.$store.getters.isAdvisor;
      },
      hideReferAFriend() {
        if (this.referAFriendEnalbed == true && this.isTestator) {
          return false;
        } else {
          return true;
        }
      },
      loggedOutItems() {
        const loggedOutItems = [
          {
            title: 'Cost calculator',
            to: '/estate-administration-cost-calculator',
          },
          {
            title: 'Financial Advisors',
            to: '/for-business',
            hide: !this.whitelabel.showFinancialAdvisorExplainerPage,
          },
          {
            title: 'How it works',
            to: this.coBrandCompanyUrl ? '#how-it-works' : '/#how-it-works',
          },
          {
            title: 'About Us',
            to: '/#about-us',
            hide: !this.whitelabel.showHomePageAbout,
          },
          {
            title: 'Executorship',
            to: '/executor-explainer',
            hide: !this.whitelabel.showExecutorExplainerPage,
          },
          {
            title: 'FAQs',
            href: this.whitelabel.FAQUrl,
            target: '_blank',
            hide: !this.whitelabel.FAQUrl,
          },
          {
            title: 'Blog',
            href: this.whitelabel.blogUrl,
            target: '_blank',
            hide: !this.whitelabel.blogUrl,
          },
        ];

        return loggedOutItems;
      },
      canSeeAdvisorDashboard() {
        return (
          this.$store.getters.isAdmin ||
          this.$store.getters.isAdvisor ||
          this.$store.getters.isCompanyAdmin ||
          this.$store.getters.isFiduciaryConsultant ||
          this.$store.getters.isCallCenterAgent ||
          this.$store.getters.isBranchAgent
        );
      },
      showEditMyPeople() {
        return (
          this.testator &&
          this.testator.steps &&
          this.testator.steps.people &&
          !this.isCompanyAdminOrAdvisor
        );
      },
      showExecutorship() {
        if (!this.whitelabel.showExecutorExplainerPage) return false;

        return (
          !this.isCompanyAdminOrAdvisor &&
          this.testator &&
          (!this.testator.company ||
            this.testator.company.executorship == 'INTERNAL_COMPANY_ONLY' ||
            this.testator.company.executorship == 'INTERNAL_COMPANY_OR_PERSON')
        );
      },
      showWillVerification() {
        return this.testator && this.testator.willVersions.length;
      },
      showMyDocuments() {
        return !!this.testator;
      },
      companyLogoUrl() {
        if (this.isLoggedIn && this.testator) {
          if (this.testator.company && this.testator.company.logoUrl) {
            return this.testator.company.logoUrl;
          }
        }
        return null;
      },
      logoUrl() {
        return this.whitelabel.images.logo
          ? require('@/assets/' + this.whitelabel.images.logo)
          : null;
      },
      showLoginAndSignupBtns() {
        return !this.isLoggedIn && this.$route.name != 'UserLinkLandingPage';
      },
      isCompanyAdminOrAdvisor() {
        return (
          this.$store.getters.isAdvisor || this.$store.getters.isCompanyAdmin
        );
      },
      showRequestACallBtn() {
        return (
          this.isLoggedIn &&
          this.testator &&
          this.testator.company?.contactCenterWorkflow &&
          this.$store.getters.isTestator &&
          this.testator.steps.aboutYourself
        );
      },
      showSpeakToAnAdvisor() {
        return (
          this.isLoggedIn &&
          this.testator &&
          this.testator.company?.advisorAppointment &&
          this.$store.getters.isTestator &&
          this.testator.advisor?.appointmentLink
        );
      },
      isMobile() {
        return this.$isMobileDevice();
      },
      showDesktopNav() {
        return this.$vuetify.breakpoint.width >= 1440;
      },
    },
    methods: {
      actionSelected(action) {
        if (action === 'request_advisor_access') {
          this.advisorAccessDialogOpen = !this.advisorAccessDialogOpen;
        }
      },
      closedDialog() {
        this.advisorAccessDialogOpen = false;
      },
      speakToAnAdvisorClicked() {
        this.getAdvisorAppointmentLink();
        this.sendGADataLayer();
      },
      getAdvisorAppointmentLink() {
        this.$apollo
          .mutate({
            mutation: GET_ADVISOR_APPOINTMENT_LINK,
            variables: {
              testatorId: this.testatorId,
            },
          })
          .then(response => {
            if (response.data.getAdvisorAppointmentLink) {
              const link = response.data.getAdvisorAppointmentLink;
              window.open(link, '_blank');
            } else {
              throw `The advisor for the testator with id ${this.testatorId} does not have an appointment link assigned.`;
            }
          })
          .catch(error => {
            throw error;
          });
      },
      sendGADataLayer() {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'speak-to-an-advisor',
          omuserid: this.$store.getters?.userId,
        });
      },
      logout() {
        if (this.isLoggedInAsSomeoneElse) {
          this.logoutAsTestator();
          return;
        }

        const id = this.userId;
        this.$apollo
          .mutate({
            mutation: LOGOUT_MUTATION,
            variables: { id },
          })
          .then(() => {
            this.$store.dispatch('logout');
            this.$router.push('/');
          });
      },
      menuItems() {
        if (this.isLoggedIn) {
          return this.loggedInItems;
        } else {
          return this.loggedOutItems;
        }
      },
    },
    apollo: {
      testator: {
        query: TESTATOR_STEPS_QUERY,
        variables() {
          return {
            id: this.testatorId,
          };
        },
        skip() {
          return !this.isLoggedIn || !this.testatorId;
        },
      },
      testatorSteps: {
        query: TESTATOR_STEPS_QUERY,
        variables() {
          return {
            id: this.testatorId,
          };
        },
        skip() {
          return !this.isLoggedIn || !this.testatorId;
        },
        fetchPolicy: 'network-only',
        update: data => data.testator.steps,
      },
    },
  };
</script>

<style lang="scss">
  @import '../../constants/styles/mixins.scss';

  .partnered-with {
    background-color: var(--v-primary-base);
    color: #ffffff;

    .partnered-with-text {
      margin-top: 2px;
      margin-bottom: 2px;
    }
  }

  .menu-toolbar-logged-in {
    box-shadow: 0px 4px 5px 0px rgba(0, 0, 0, 0.02) !important;
  }

  .menu-toolbar {
    box-shadow: none;
    min-height: 60px;
    z-index: 1;

    .hidden {
      display: none;
    }

    .v-btn {
      font-size: 16px !important;
      font-weight: 500 !important;
      line-height: 24px !important;
    }

    .menubar-title {
      position: relative;
      overflow: unset;

      .menubar-logo {
        width: auto;
        max-width: 213px;
        max-height: 50px;
        margin-top: 15px;
      }

      .internal-main-logo {
        width: 100%;
      }

      .right-side-logo {
        float: right;
        max-width: 155px;
        margin-top: 20px;
      }

      .powered-by {
        font-size: 10px;
        max-width: 213px;
        color: #000;
        display: none;
        text-transform: capitalize;
      }

      .logo-link {
        vertical-align: top;
        display: inline-block;
        text-align: center;
        text-decoration: none !important;
      }

      .internal-logo-css-only {
        position: absolute;
        left: 40px;
        top: -4px;
        z-index: 100;

        @media screen and (max-width: 600px) {
          left: 0;
        }
      }

      .internal-logo-css-only.right-side-logo {
        left: unset;
        right: 0;
        margin-top: 0;
      }

      @media screen and (max-width: 1180px) {
        .powered-by {
          display: block;
        }

        .right-side-logo {
          display: none;
        }

        .company-logo {
          max-height: 37px;
          max-width: 213px;
          margin-top: 8px;
        }
      }

      @media screen and (max-width: 450px) {
        margin-left: 0;
      }
    }
    .menu-btn {
      border-bottom: 2px solid transparent;
      border-radius: 0;
      height: 40px !important;
      margin: 0 10px !important;
      padding: 0 6px !important;

      &:before {
        color: transparent;
      }

      &:hover {
        -webkit-transition: none;
        transition: none;
      }

      :active {
        background: none;
      }
    }

    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
      /* IE10+ CSS styles go here */
      .v-toolbar__items {
        margin-top: 20px;
      }
    }

    @media screen and (max-width: 1315px) {
      .menu-btn.edit-my-people {
        display: none;
      }
    }

    @media screen and (max-width: 400px) {
      .v-toolbar__content {
        padding-left: 8px;
        padding-right: 0;
      }
    }
  }

  .mobile-menu-link {
    width: 100%;
    margin: 0 !important;
    padding: 0 30px !important;

    &:hover {
      -webkit-transition: none;
      transition: none;
    }

    &:hover:before {
      background: none !important;
    }
  }
  .mobile-menu-list-item {
    padding: 0 !important;
    margin: 0 11px;
  }

  @media only screen and (min-width: 0px) and (max-width: 959px) {
    .menu-toolbar {
      .v-btn {
        font-size: 12px !important;
        font-weight: 500 !important;
        line-height: 18px !important;
        padding-left: 9px !important;
        padding-right: 9px !important;
        padding-top: 6px !important;
        padding-bottom: 6px !important;
      }
    }
  }
  .menu-toolbar-mobile {
    padding-right: 5px;
  }

  .nav-mobile-menu {
    z-index: 200 !important;
  }
</style>
